export enum VerificationState {
  PARTNER_VERIFIED = 'PARTNER_VERIFIED',
  IN_PROGRESS = 'IN_PROGRESS',
  VERIFIED = 'VERIFIED',
  FAILED = 'FAILED',
  NA = 'NA'
}
